import { render, staticRenderFns } from "./customer-product-lastest.vue?vue&type=template&id=1e69f095&scoped=true"
import script from "./customer-product-lastest.vue?vue&type=script&lang=js"
export * from "./customer-product-lastest.vue?vue&type=script&lang=js"
import style0 from "./customer-product-lastest.vue?vue&type=style&index=0&id=1e69f095&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e69f095",
  null
  
)

export default component.exports